import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { RouterModule } from '@angular/router';
import { ClickOutsideDirective } from '../shared/directives/clickoutside/click-outside.directive';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { NavComponent } from './layout/nav/nav.component';
// import { ClickOutsideDirective } from '../shared/directives/click-outside/click-outside.directive';

@NgModule({
  declarations: [ NavComponent, MainLayoutComponent, ClickOutsideDirective],
  imports: [
    BrowserModule,
    RouterModule,
    HttpClientModule
  ],
  exports: [MainLayoutComponent],
})
export class CoreModule {}
